import { render, staticRenderFns } from "./CsDrawerFooter.vue?vue&type=template&id=0555bb60&"
import script from "./CsDrawerFooter.vue?vue&type=script&setup=true&lang=js&"
export * from "./CsDrawerFooter.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports